import { useState } from "react";
import StyleWrapper, {
    StyleContentWrapper,
    StyleFlexPrizes,
} from "./style";

export default ({setIsModalOpen}) => {
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleFlexPrizes>
                        <div>
                            <img
                                src="/assets/img/premio-description.png"
                                alt="Prêmios"
                            />
                            <p>*limitado a um prêmio por CPF.</p>
                        </div>
                        <div>
                            <img
                                src="/assets/img/premio.png"
                                alt="Prêmios"
                            />
                        </div>
                        
                    </StyleFlexPrizes>
                    <div>
                        <p>
                            Período de participação: de 11/05/2025 a 11/08/2026.
                            Serão considerados válidos apenas os teste drives realizados nas concessionárias participantes e que atendam aos parâmetros descritos no regulamento, limitado a um prêmio por CPF. 
                            Certificado de autorização N.° 04.049765/2026.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
